import { selectLanguage } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { selectActiveVariant } from '@ff-scene-plugins/gift-redux/selectors/variantSelectors';
import { selectVariablePaintables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { Size } from 'ff-canvas';
import { createFullPreviewSpaces } from './preview/helpers/createFullPreviewSpaces';
import { renderGiftThumbnail } from './renderGiftThumbnail';

export const renderProjectToThumbnail = async (
    state: GiftPdpState,
    targetSize: Size
): Promise<Blob> => {

    const { scene } = state;
    const { meta } = state.project;

    const language = selectLanguage(state);
    const variant = selectActiveVariant(state);
    const paintables = selectVariablePaintables(state, 'mockup');

    const sceneSize = { width: scene.options.width, height: scene.options.height };
    const designArea = variant.options.designArea ?? variant.options.viewbox!;
    const metaViewbox = { width: meta.viewboxWidth, height: meta.viewboxHeight };

    const spaces = createFullPreviewSpaces(sceneSize.width, sceneSize.height, designArea, metaViewbox);

    return await renderGiftThumbnail(paintables, variant, spaces, sceneSize, targetSize, language);
};